import React, { useState, useEffect } from 'react';
import { Col, Row, Card, CardBody, Button, CardHeader, Form, Alert } from 'reactstrap';
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";

import FormDatePicker from '../../components/Controls/FormDatePicker';
import FormDropDown from '../../components/Controls/FormDropDown';
import FormSubmitButton from '../../components/Controls/FormSubmitButton';

import configService from '../../services/configService';
import { useNotification } from '../../services/notification';
import videoPlatformMediaService from '../../services/videoPlatformMediaService';

import MediaPurgeConfirmation from './MediaPurgeConfirmation'

const MediaPurge = () => {

    const [allShows, setAllShows] = useState([]);
    useEffect(() => {
        configService.shows()
            .then(data => setAllShows(data));
    }, []);
    const [modalData, setModalData] = useState(null);
    const notification = useNotification();
    const { register, handleSubmit, watch, reset, control, formState } = useForm();
    const { errors, isSubmitting } = formState;
    const dates = watch({ startDate: "startDate", endDate: "endDate" });



    const onModalCancel = () => {
        setModalData(null);
    }

    const onModalSubmitted = (data) => {
        setModalData(null);
        reset();
        notification.success(`${data.count} medias removed from Limelight. It may take up to 5 minutes for changes to be reflected.`);
    }

    const onSubmit = async (data) => {
        await videoPlatformMediaService.search(data.show, data.startDate, data.endDate)
            .then(response => {
                if (response.count == 0) notification.error("No media to remove for those critera.")
                else setModalData(response)
            }
        );
    }

    const validations = {
        show: {
            required: "Show is required",
        },
        startDate: {
            required: "Start date is required"
        },
        endDate: {
            validate: {
                validDateRange: value => (value && dates?.startDate && value >= dates.startDate) || "End date cannot be before start date."
            },
            required: "End date is required",
        }
    }

    return (
        <>
            {
            modalData &&
                <MediaPurgeConfirmation
                    data={modalData}
                    onCancel={onModalCancel}
                    onSubmitted={onModalSubmitted}
                />
            }
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <h3>Purging medias removes media files from Limelight and the Media Flow database.</h3>
                        </CardHeader>
                        <CardBody>
                            <Alert color="default">This action irreversible. <strong>Use with EXTREME caution.</strong></Alert>
                            <Form key="formPurge" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col>
                                        <FormDropDown
                                            register={register}
                                            name="show"
                                            labelText="Show"
                                            validations={validations.show}
                                            errors={errors.show}
                                        >
                                            <option value=""></option>
                                            {
                                                (allShows || []).map(
                                                    (s) => <option
                                                        key={s.toString().toLowerCase()}
                                                        value={s}>
                                                        {s}
                                                    </option>
                                                )
                                            }
                                        </FormDropDown>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="6">
                                        <FormDatePicker
                                            labelText="Start Date"
                                            name="startDate"
                                            control={control}
                                            validations={validations.startDate}
                                            selectsStart
                                            errors={errors.startDate}
                                            maxDate={dates["endDate"]}
                                            isStartOfDay
                                        />
                                    </Col>
                                    <Col lg="6">
                                        <FormDatePicker
                                            labelText="End Date"
                                            name="endDate"
                                            control={control}
                                            selectsEnd
                                            validations={validations.endDate}
                                            errors={errors.endDate}
                                            minDate={dates["startDate"]}
                                            isEndOfDay
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormSubmitButton
                                            text="Purge"
                                            isSubmitting={isSubmitting} />
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default MediaPurge;
